<template>
    <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">

        <v-dialog v-model="dialog_edit" max-width="290">
            <v-card>
                <v-card-title class="text-h5">Edit level: {{ dialog_edit_index }}</v-card-title>
                <v-card-text>Select used colors and type of cauldron.</v-card-text>
            </v-card>
        </v-dialog>

        <v-card>
            <v-card-title>
                <span class="headline">Novice Battle Pass Bundle ({{ this.rules.name }})</span>
            </v-card-title>
            <v-card-text>

                <v-row dense class="mb-4 pt-4">
                    <v-col cols="12" md="12" sm="12">
                        <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
                    </v-col>
                    <v-text-field
                      label="Name"
                      v-model.trim="model.name"
                      class="mr-2"
                      v-ascii-only
                    />
                    <v-text-field
                      label="Key"
                      v-model.trim="model.key"
                      v-ascii-only
                    />
                </v-row>

                <v-row dense class="mt-3">
                    <v-card width="100%" class="ma-0 pa-2 mt-2 pb-0" elevation="0" outlined>
                        <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
                            <v-card-title class="blue--text pa-0 ma-0 ml-1">Days</v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn icon elevation="0" color="white" dense class="green--text" @click="add_day()">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-card-actions>
                        <v-card width="100%" class="ma-0" elevation="0" outlined>

                            <v-list class="ma-0 pa-0">

                                <v-list-group
                                  v-for="(day) in model.days"
                                  :key="day.uid"
                                  :value="expandedDayUID === day.uid"
                                  @input="toggleExpand(day.uid)"
                                  no-action
                                >

                                    <template v-slot:activator>
                                        <v-card
                                          elevation="0"
                                          outlined
                                          width="100%"
                                          :color="expandedDayUID === day.uid ? 'blue' : undefined"
                                          class="d-flex pa-1 pl-3 ma-1"
                                          :class="expandedDayUID === day.uid ? 'white--text' : 'black--text'"
                                        >

                                            <v-list-item-title >{{ day.name }}, quests: {{ day.quests.length }}, latency: {{ day.latency }}</v-list-item-title>

                                            <v-card elevation="0" class="pa-1 d-flex align-center">
                                                <v-icon @click.stop="edit_day(day.uid)" class="mr-2" small color="grey">mdi-pencil</v-icon>
                                                <v-icon @click.stop="remove_day(day.uid)" class="mr-2" small color="red">mdi-delete</v-icon>
                                                <v-icon @click.stop="add_quest(day.uid)" small color="green">mdi-plus</v-icon>
                                            </v-card>

                                        </v-card>

                                    </template>

                                    <v-list-item>

                                        <v-card outlined height="100%" width="100%">
                                            <v-data-table
                                              :headers="header_quests"
                                              :items="day.quests"

                                              item-key="uid"
                                              disable-pagination
                                              hide-default-footer
                                              dense
                                              style="white-space: nowrap; width: 100%;"
                                            >

                                                <template v-slot:item.actions="{item: questItem}">
                                                    <v-icon @click="edit_quest_in_day(day.uid, questItem.uid)" class="mr-2" small color="grey">mdi-pencil</v-icon>
                                                    <v-icon @click="moveup_quest_in_day(day.uid, questItem.uid)" class="mr-2" small color="blue">mdi-arrow-up-thick</v-icon>
                                                    <v-icon @click="movedown_quest_in_day(day.uid, questItem.uid)" class="mr-2" small color="blue">mdi-arrow-down-thick</v-icon>
                                                    <v-icon @click="remove_quest_in_day(day.uid, questItem.uid)" small color="red">mdi-delete</v-icon>
                                                </template>

                                            </v-data-table>

                                        </v-card>

                                    </v-list-item>

                                </v-list-group>

                            </v-list>
                        </v-card>
                        <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
                        </v-card-actions>
                    </v-card>
                    <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
                        <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Reward Tracks</v-card-title>
                        <v-expansion-panels v-if="model">
                            <r-reward-track-panel :model.sync="model.rewards" title="Reward Track"/>
                            <r-reward-track-panel :model.sync="model.rewards_premium" :payable="true" :reminder="true"  title="Premium Track"/>
                        </v-expansion-panels>
                    </v-card>

                    <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
                        <v-card-title class="red--text pa-0 ma-0 ml-1 mb-2">Guards</v-card-title>
                        <v-expansion-panels>
                            <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
                            <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
                        </v-expansion-panels>
                    </v-card>

                    <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
                        <v-card-title class="green--text pa-0 ma-0 ml-1 mb-2">Tooltip</v-card-title>
                        <v-row dense class="ml-3 mr-3 pb-3">
                            <v-text-field v-model.number="model.iconBadgeExpires" label="Icon Badge Expires" hide-details class="pr-4"/>
                            <v-text-field v-model.number="model.iconTooltipReset" label="Icon Tooltip Reset" hide-details/>
                        </v-row>
                    </v-card>

                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
        <r-smart-offer-bundle-novice-battle-pass-quest-edit-dialog ref="dialog-quests"/>
        <r-smart-offer-bundle-novice-battle-pass-day-edit-dialog ref="dialog-days"/>
    </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import {SmartOfferBundleNoviceBattlePass} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePass";
import {SmartOfferBundleNoviceBattlePassDay} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDay";
import {SmartOfferBundleNoviceBattlePassDayQuest} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePassDayQuest";
import RSmartOfferBundleNoviceBattlePassDayEditDialog from "@/modules/redactor/views/smart-offer/bundle-novice-battle-pass/r-smart-offer-bundle-novice-battle-pass-day-edit-dialog";
import RSmartOfferBundleNoviceBattlePassQuestEditDialog from "@/modules/redactor/views/smart-offer/bundle-novice-battle-pass/r-smart-offer-bundle-novice-battle-pass-quest-edit-dialog";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel";

export default {
    name: "r-smart-offer-bundle-novice-battle-pass",
    components: {
        RRewardTrackPanel,
        RSmartOfferBundleNoviceBattlePassDayEditDialog,
        RSmartOfferBundleNoviceBattlePassQuestEditDialog,
        RGuardMoneyPanel,
        RGuardPanel
    },
    data: () => ({
        dialog_edit_index: 0,
        dialog_edit: false,
        dialog: false,
        resolve: null,
        reject: null,
        tab: null,
        model: new SmartOfferBundleNoviceBattlePass(),
        rules: ViewRules.READONLY,
        header_quests: [
            {text: "Name", value: "name"},
            {text: "Key", value: "key"},
            {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
        ],
        expandedDayUID: null,
    }),
    computed: {
    },
    methods: {
        show(rules, model) {

            this.dialog = true;
            this.tab = null;
            this.rules = rules;
            this.model = model;

            if (!this.model) {
                this.generateRandom();
            }

            console.log(this.model);

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        generateRandom(){

            this.model = new SmartOfferBundleNoviceBattlePass();
            this.model.days = [];

            const totalDays = 3;

            for (let dayIndex = 0; dayIndex < totalDays; dayIndex++) {

                const day = new SmartOfferBundleNoviceBattlePassDay();

                day.key = `k${dayIndex}`;
                day.name = `Day ${dayIndex + 1}`;
                day.quests = [];

                const questCount = Math.floor(Math.random() * 15) + 1;

                for (let questIndex = 0; questIndex < questCount; questIndex++) {
                    const quest = new SmartOfferBundleNoviceBattlePassDayQuest();
                    quest.key = `k${questIndex}`;
                    quest.name = `Quest ${dayIndex + 1}.${questIndex + 1}`;
                    day.quests.push(quest);
                }


                this.model.days.push(day);
            }
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config!");
            }
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        },
        onenter() {
            this.save();
        },
        edit_quest_in_day(day_uid, quest_uid) {
            const day = this.model.days.find(d => d.uid === day_uid);
            if (!day || !Array.isArray(day.quests)) {
                return;
            }
            const quest = day.quests.find(q => q.uid === quest_uid);
            if (!quest) {
                return;
            }
            this.$refs['dialog-quests'].show(quest).catch(() => {

            });
        },
        swap(array, i, j) {
            if (i < 0 || j < 0 || i >= array.length || j >= array.length) return;
            const temp = array[i];
            this.$set(array, i, array[j]);
            this.$set(array, j, temp);
        },
        moveup_quest_in_day(day_uid, quest_uid) {
            const day = this.model.days.find(d => d.uid === day_uid);
            if (!day || !Array.isArray(day.quests)) return;
            const index = day.quests.findIndex(q => q.uid === quest_uid);
            if (index > 0) {
                this.swap(day.quests, index, index - 1);
            }
        },
        movedown_quest_in_day(day_uid, quest_uid) {
            const day = this.model.days.find(d => d.uid === day_uid);
            if (!day || !Array.isArray(day.quests)) return;
            const index = day.quests.findIndex(q => q.uid === quest_uid);
            if (index >= 0 && index < day.quests.length - 1) {
                this.swap(day.quests, index, index + 1);
            }
        },
        remove_quest_in_day(day_uid, quest_uid) {
            this.$confirm("Are you sure you want to delete this item?").then(() => {
                const day = this.model.days.find(d => d.uid === day_uid);
                if (!day || !Array.isArray(day.quests)) {
                    return;
                }
                const questIndex = day.quests.findIndex(q => q.uid === quest_uid);
                if (questIndex === -1) {
                    return;
                }
                day.quests.splice(questIndex, 1);
            });
        },
        add_day() {
            const day = new SmartOfferBundleNoviceBattlePassDay();
            day.name = "New Day";
            if (!this.model.days) {
                this.$set(this.model, 'days', []);
            }
            this.model.days.push(day);
        } ,
        edit_day(day_uid) {
            const day = this.model.days.find(d => d.uid === day_uid);
            if (!day) return;
            this.$refs['dialog-days'].show(day).catch(() => {

            });
        },
        remove_day(day_uid) {
            this.$confirm("Are you sure you want to delete this item?").then(() => {
                const index = this.model.days.findIndex(day => day.uid === day_uid);
                if (index !== -1) {
                    this.model.days.splice(index, 1);
                }
            });
        }
        ,add_quest(day_uid) {
            const quest = new SmartOfferBundleNoviceBattlePassDayQuest();
            quest.key = `new_quest`;
            quest.name = `Quest new`;
            const day = this.model.days.find(d => d.uid === day_uid);
            if (!day) return;
            if (!day.quests) {
                this.$set(day, 'quests', []);
            }
            day.quests.push(quest);
        },
        toggleExpand(day_uid) {
            this.expandedDayUID = this.expandedDayUID === day_uid ? null : day_uid;
        },
    }
}
</script>